import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';
import { routes } from '@/lib/routes';

/**
 * Rendered when the URL `:spaceId` doesn't resolve against `/me/spaces`. The
 * user either typed / followed a link to a space that belongs to a different
 * org or that they were removed from, OR the id is malformed.
 *
 * We render a clear empty-state instead of letting child routes mount with a
 * stale `spaceId`, which would otherwise fire 403/404 backend calls and leak
 * a broken-looking shell of someone else's UI.
 */
export function ForbiddenSpace() {
  return (
    <div
      data-testid="space-forbidden"
      className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <ShieldAlert className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
      <div className="space-y-1">
        <h1 className="text-xl font-semibold text-foreground">
          You don't have access to this space
        </h1>
        <p className="max-w-md text-sm text-muted-foreground">
          The space you're trying to open either doesn't exist, belongs to a
          different organization, or you've been removed from it.
        </p>
      </div>
      <Link to={routes.console.root} className={buttonVariants()}>
        Go to your spaces
      </Link>
    </div>
  );
}
